export default __webpack_public_path__ + "static/media/6.59617bd1.webp";